import { render } from "./AppGuideModal.vue?vue&type=template&id=04a19c1c&scoped=true"
import script from "./AppGuideModal.vue?vue&type=script&lang=js"
export * from "./AppGuideModal.vue?vue&type=script&lang=js"

import "./AppGuideModal.vue?vue&type=style&index=0&id=04a19c1c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a19c1c"]])

export default __exports__